import { TableRow } from "../../../components/DataTable/DataTable";
import { TruckLoadDTO } from "../../../DTOs/Production/TruckLoadDTO";

export const truckLoadFromTableRow = (
  row: TableRow<number>,
  rowVersion: string | undefined,
  diggingPatternId: number,
  hour: number,
): TruckLoadDTO => new TruckLoadDTO({
  loadingId: row.id,
  diggingPatternId,
  destinationId: row.values.find(v => v.name === "Destination")?.value,
  truckId: row.values.find(v => v.name === "Truck")?.value,
  loads: row.values.find(v => v.name === "Loads")?.value,
  hour,
  materialTypeClassId: row.values.find(v => v.name === "Material Type Class")?.value,
  rowVersion,
});
